import templateStr from 'text!./note-view.html';

export default [() => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            note: '=',
            showTopic: '='
        },
        controller: ['$scope', 'InsuranceSuiteMetadata', ($scope, InsuranceSuiteMetadata) => {
            if (angular.isDefined($scope.showTopic)) {
                $scope.topic = InsuranceSuiteMetadata.get('pc').types.getTypelist('NoteTopicType').getCode($scope.note.topic);
            }
        }]
    };
}];
